import React, { Component } from "react";
import DatiSegnalazioneAnagrafici from "../WizardSteps/DatiSegnalazioneAnagrafici/DatiSegnalazioneAnagrafici";
import DatiSanitari from "../WizardSteps/DatiSanitari/DatiSanitari";
import Esito from "../WizardSteps/Esito/Esito";
import InfoCliniche from "../WizardSteps/InfoCliniche/InfoCliniche";
import Spinner from "../../../components/spinner/Spinner";
import { states } from "../States/States";
import { Redirect } from "react-router";
import DatiSpecifici from "../WizardSteps/DatiSpecifici/DatiSpecifici";
import Button from "../../../components/button/Button";
import stylesInfoCliniche from "../WizardSteps/InfoCliniche/InfoCliniche.module.css";
import Icon from "../../../components/icon/Icon";
import TableDatiUtente from "../../../components/tableDatiUtente/TableDatiUtente";
import SegnalazioniService from "../../../services/SegnalazioniServices";
import styles from "../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import Table from "../../../components/table/Table";
import { withTranslation } from "react-i18next";
import OggettiUtili from "../../../utils/OggettiUtili";
import { StepProgressBar } from "../StepProgressBar/StepProgressBar";
import Utils from "../../../utils/Utils";
import SchedaSpeciale from "../WizardSteps/SchedaSpeciale/SchedaSpeciale";
import SessioneUtente from "../../../sessionManager/SessioneUtente";
import MalattieService from "../../../services/MalattieService";
import PazientiService from "../../../services/PazientiService";
import MediciService from "../../../services/MediciService";
import SchedaSpecialeTrattamentoTbc from "../WizardSteps/SchedaSpecialeTrattamentoTBC/SchedaSpecialeTrattamentoTbc";
import Ruoli from "../../../utils/Ruoli.json";
import styleWizardPanel from "./WizardPanel.module.css";
import ToasterSingleton from "../../../singleton/ToasterSingleton";
import toasterConfig from "../../../config/toasterConfig";
import history from "../../../utils/History";
import {labelConfig} from "../../../config/labelConfig";

class WizardPanel extends Component {
    state = {
        currentState: states.DATI_SEGNALAZIONE_E_ANAGRAFICI,
        datiPaziente: {},
        datiMedico: {},
        loading: false,
        mostraTabellaSegnalazioni: false,
        rowsTabSegnalazioni: [],
        totalElementsTabSegnalazioni: 0,
        pageTabSegnalazioni: 0,
        totalPagesTabSegnalazioni: 0,
        sizeTabSegnalazioni: 10,
        segnalazione: {},
        segnalazioneCopia: {},
        datiCompletiECorretti: [],
        infoMalattia: "",
        malattiaStep1: "",
        listaSezioni: this.props.location.listaSezioni
            ? this.props.location.listaSezioni
            : "",
        step: "",
        informazioneMalattia: "",
        navLabel: {},
        schedaSpeciale: false,
        infoLaboratorio:{
            infoLaboratorio :this.props.location.infoLaboratorio,
            tipoLaboratorio:this.props.location.tipoLaboratorio,
            dataEsame:this.props.location.dataEsame,
            dataPrelievo:this.props.location.dataPrelievo,
            listaDettaglioLab:this.props.location.listaDettaglioLab,
            autore:this.props.location.autore
        }
    };

    constructor(props) {
        super(props);
        let datiCompleti = Utils.getCompletezzaStep(this.state.segnalazione);
        this.state.datiCompletiECorretti = datiCompleti;
        if (
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.schedaSpeciale
        ) {
            this.state.schedaSpeciale = true;
        }
        this.showLoadingSpinner = this.showLoadingSpinner.bind(this);
        this.sendRequest = this.sendRequest.bind(this);
        this.mostraTabellaSegnalazioni =
            this.mostraTabellaSegnalazioni.bind(this);
        this.setSegnalazione = this.setSegnalazione.bind(this);
        this.changePageTable = this.changePageTable.bind(this);
        this.changePaginationTable = this.changePaginationTable.bind(this);
        this._currentStep = this._currentStep.bind(this);
        this.callInfoMalattia = this.callInfoMalattia.bind(this);
        this.setInfoMalattia = this.setInfoMalattia.bind(this);
        this.setStateGenerico = this.setStateGenerico.bind(this);
        this.navLabel = this.navLabel.bind(this);
        this.updateState = this.updateState.bind(this);
        this.setMalattiaStep1 = this.setMalattiaStep1.bind(this);
        this.aggiungiToaster = this.aggiungiToaster.bind(this);
        this.onClickTornaAllaRicerca = this.onClickTornaAllaRicerca.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.location.state &&
            this.props.location.state.currentState &&
            this.props.location.state.currentState !== this.state.currentState &&
            this.props.location.state.currentState !== prevState.currentState
        ) {
            if (this.props.location.state) {
                this.setState(this.props.location.state);
            }
        }

        if (prevState.currentState !== this.state.currentState) {
            Utils.scrollToTheTop();
            this.callInfoMalattia();
        } else if (prevState.malattiaStep1 !== this.state.malattiaStep1) {
            this.callInfoMalattia(null, true);
        }
    }

    componentWillUnmount() {
        ToasterSingleton.instance().cancellazioneSottoscrizione();
        ToasterSingleton.instance().pulisci();
        this.props.navLabel({navLabel: {}})
    }

    // colonne tabella segnalazioni
    colsTabSegnalaioni = [
        {
            key: "idSegnalazione",
            name: "Tables.InformazioniSegnalazione.idSegnalazione",
            sortDirection: "none",
            tipo: "tooltip",
        },
        {
            key: "malattia",
            name: "Tables.InformazioniSegnalazione.malattia",
            sortDirection: "none",
        },
        {
            key: "ulssSegnalazione",
            name: "Tables.InformazioniSegnalazione.ulssSegnalazione",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: OggettiUtili.Ulss
        },
        {
            key: "dataSegnalazione",
            name: "Tables.InformazioniSegnalazione.dataSegnalazione",
            sortDirection: "none",
            tipo: "data",
        },
        {
            key: "statoSegnalazione",
            name: "Tables.InformazioniSegnalazione.stato",
            sortDirection: "none",
            tipo: "pallino",
            oggetto: OggettiUtili.statoSegnalazione,
        },
    ];

    callInfoMalattia(step, nuovaMalattia) {
        if (
            this.state.malattiaStep1 ||
            (Utils.isEmpty(this.state.infoMalattia) &&
                this.state.informazioneMalattia) ||
            (Utils.isEmpty(this.state.infoMalattia) &&
                this.state.currentState === "DATI_SANITARI") ||
            (Utils.isEmpty(this.state.infoMalattia) &&
                this.state.segnalazione.malattia)
        ) {
            MalattieService.getInfoMalattia(
                this.state.malattiaStep1
                    ? this.state.malattiaStep1
                    : this.state.informazioneMalattia
                    ? this.state.informazioneMalattia
                    : this.props.location && this.props.location.malattia
                    ? this.props.location.malattia
                    : this.state.segnalazione.malattia
            )
                .then((data) => {
                    /* console.log(
                        "INFO MALATTIA DATI SPECIFICI: " +
                            JSON.stringify(Object.values(data.data))
                    ); */
                    if (step) {
                        this.setState({
                            infoMalattia: data.data,
                            informazioneMalattia: "",
                            schedaSpeciale: false,
                            currentState: step,
                        });
                    } else {
                        this.setState({
                            infoMalattia: data.data,
                            informazioneMalattia: "",
                            schedaSpeciale: false,
                        });
                        this._currentStep();
                    }
                })
                .catch(() => {
                    console.log("errore chiamata InfoMalattia");
                    this._currentStep();
                });
        } else {
            this._currentStep();
        }
        if (
            !this.state.listaSezioni ||
            this.state.listaSezioni.length <= 0 ||
            nuovaMalattia
        ) {
            MalattieService.getSezioni(
                this.state.malattiaStep1
                    ? this.state.malattiaStep1
                    : this.state.informazioneMalattia
                    ? this.state.informazioneMalattia
                    : this.props.location && this.props.location.malattia
                    ? this.props.location.malattia
                    : this.state.segnalazione.malattia
            )
                .then((data) => {
                    this.showLoadingSpinner(false);
                    let res = Utils.mapToArray(data.data);
                    console.log("lista: " + res);
                    this.setState({ listaSezioni: res });
                })
                .catch(() => {
                    console.log("errore chiamata ListaSezioni");
                });
        }
    }

    componentDidMount() {
        Utils.scrollToTheTop();
        ToasterSingleton.instance().sottoscrizione(this);
        let object = {
            label: labelConfig.wizardSegnalazione[0],
        }
        this.props.navLabel({navLabel: object})
        let idSegnalazione = this.props.location.idSegnalazione;
        this.showLoadingSpinner(true);
        // se esiste già una segnalazione - siamo in modifica
        if (idSegnalazione) {
            // retrieve dati segnalazione dal server
            SegnalazioniService.getSingolaSegnalazione(idSegnalazione)
                .then((data) => {
                    this.showLoadingSpinner(false);
                    let datiCompleti = Utils.getCompletezzaStep(data.data);
                    let datiPaziente = this.state.datiPaziente;
                    let datiMedico = this.state.datiMedico;
                    let stepConfermati = data.data.stepConfermati;
                    let step = states.DATI_SEGNALAZIONE_E_ANAGRAFICI;
                    // definisci lo step attuale
                    if (stepConfermati) {
                        if (!stepConfermati.datiSanitariConfermati) {
                            step = states.DATI_SANITARI;
                        } else {
                            if (!stepConfermati.infoConfermate) {
                                step = states.INFO_CLINICHE;
                            } else {
                                if (!stepConfermati.esitoConfermato) {
                                    step = states.ESITO;
                                } else {
                                    if (
                                        !stepConfermati.datiSpecificiConfermati ||
                                        (stepConfermati.datiSpecificiConfermati &&
                                            !data.data.schedaSpecialePresente)
                                    ) {
                                        step = states.DATI_SPECIFICI;
                                    } else {
                                        if (
                                            !stepConfermati.schedaSpecialeConfermata ||
                                            (stepConfermati.schedaSpecialeConfermata &&
                                                data.data
                                                    .schedaSpecialePresente)
                                        ) {
                                            step = states.SCHEDA_SPECIALE;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    let segnalazione = Utils.removeFieldFromObject(
                        data.data,
                        "_id"
                    );
                    // ritorniamo da server dati paziente e medico
                    let idMedico = data.data.medicoId;
                    datiPaziente.malattia = segnalazione.malattia;
                    PazientiService.letturaPaziente(data.data.pazienteId)
                        .then((data) => {
                            datiPaziente = Utils.mapGetPazientePerModifica(
                                data.data,
                                this.props.dataCompilazione
                            );
                            datiPaziente.malattia = segnalazione.malattia;
                            MediciService.getMedicoById(idMedico)
                                .then((data) => {
                                    datiMedico = Utils.getSingleMedico(
                                        data.data
                                    );
                                    this.setState({
                                        segnalazione: segnalazione,
                                        segnalazioneCopia: segnalazione,
                                        datiPaziente: datiPaziente,
                                        datiCompletiECorretti: datiCompleti,
                                        datiMedico: datiMedico,
                                    });
                                    this.callInfoMalattia(step);
                                    this.showLoadingSpinner(false);
                                })
                                .catch((reason) => {
                                    console.log(
                                        "[ERROR] get lettura medico: " + reason
                                    );
                                    this.aggiungiToaster([
                                        "Messages.ERR_MISS_ANAGRAFICA",
                                    ]);
                                    this.showLoadingSpinner(false);
                                });
                        })
                        .catch((reason) => {
                            console.log(
                                "[ERROR] get lettura paziente: " + reason
                            );
                            this.aggiungiToaster([
                                "Messages.ERR_MISS_ANAGRAFICA",
                            ]);
                            this.showLoadingSpinner(false);
                        });
                    this.setState({
                        currentState: step,
                        segnalazione: segnalazione,
                        segnalazioneCopia: segnalazione,
                        datiPaziente: datiPaziente,
                        datiMedico: datiMedico,
                        datiCompletiECorretti: datiCompleti,
                    });
                    this.callInfoMalattia();
                    this.showLoadingSpinner(false);
                })
                .catch(() => {
                    console.log("[Error] GetSegnalazioni in errore ");
                    this.callInfoMalattia();
                });
        } else {
            this.callInfoMalattia();
        }
    }

    aggiungiToaster(text) {
        ToasterSingleton.instance().aggiuntaToaster({
            type: toasterConfig.types.critical,
            text: text,
            timestamp: Date.now(),
        });

        this.forceUpdate();
    }

    updateState(object) {
        this.setState(object);
    }

    setSegnalazione(segnalazione) {
        this.setState({ segnalazione: segnalazione });
    }

    showLoadingSpinner(value) {
        this.setState({ loading: value });
    }

    setInfoMalattia(value) {
        this.setState({ informazioneMalattia: value });
    }

    navLabel(object) {
        this.props.navLabel(object);
    }

    setStateGenerico(object) {
        this.setState(object);
    }

    setMalattiaStep1(malattia) {
        this.setState({ malattiaStep1: malattia });
    }

    _currentStep() {
        let step = {};
        console.log("currentState " + this.state.currentState);
        switch (this.state.currentState) {
            case states.HOME:
                return <Redirect to="/ricercaSegnalazioni" />;
            case states.DATI_SEGNALAZIONE_E_ANAGRAFICI:
                step = (
                    <DatiSegnalazioneAnagrafici
                        navLabel={this.navLabel}
                        updateWizardState={this.updateState}
                        showSpinner={this.showLoadingSpinner}
                        setMalattia={this.setMalattiaStep1}
                        malattia={
                            this.props.location.malattia
                                ? this.props.location.malattia
                                : this.state.segnalazione.malattia
                        }
                        ulssSegnalazione={
                            this.props.location.ulssSegnalazione
                                ? this.props.location.ulssSegnalazione
                                : ""
                        }
                        dataSegnalazione={this.props.location.dataSegnalazione}
                        idLisSegnalazione={this.props.location.idLisSegnalazione}
                        comuneSegnalazione={this.props.location.comuneSegnalazione}
                        nomePaziente={this.props.location.nomePaziente}
                        cognomePaziente={this.props.location.cognomePaziente}
                        codiceFiscale={this.props.location.codiceFiscale}
                        dataDiNascita={this.props.location.dataDiNascita}
                        sesso={this.props.location.sesso}
                        comuneNascita={this.props.location.comuneNascita}
                        comuneResidenza={this.props.location.comuneResidenza}
                        indirizzoResidenza = {this.props.location.indirizzoResidenza}
                        comuneDomicilio={this.props.location.comuneDomicilio}
                        indirizzoDomicilio = {this.props.location.indirizzoDomicilio}
                        stp={this.props.location.stp}
                        formPazienteSpecifico={this.props.location.formPazienteSpecifico}
                        datiCompletiECorretti={this.state.datiCompletiECorretti}
                        segnalazione={
                            this.state.segnalazione
                                ? this.state.segnalazione
                                : ""
                        }
                        segnalazioneCopia={
                            this.state.segnalazioneCopia
                                ? this.state.segnalazioneCopia
                                : ""
                        }
                        infoMalattia={
                            this.state.infoMalattia
                                ? this.state.infoMalattia
                                : ""
                        }
                        setInfoMalattia={this.setInfoMalattia}
                        datiMedico={this.state.datiMedico}
                        focolai={this.props.location.focolai}
                    />
                );
                return this.setState({ step: step });
            case states.DATI_SANITARI:
                step = (
                    <DatiSanitari
                        navLabel={this.navLabel}
                        showSpinner={this.showLoadingSpinner}
                        datiCompletiECorretti={this.state.datiCompletiECorretti}
                        datiPaziente={this.state.datiPaziente}
                        datiMedico={this.state.datiMedico}
                        segnalazione={
                            this.state.segnalazione
                                ? this.state.segnalazione
                                : ""
                        }
                        segnalazioneCopia={
                            this.state.segnalazioneCopia
                                ? this.state.segnalazioneCopia
                                : ""
                        }
                        updateWizardState={this.updateState}
                    />
                );
                return this.setState({ step: step });
            case states.INFO_CLINICHE:
                step = (
                    <InfoCliniche
                        navLabel={this.navLabel}
                        datiPaziente={this.state.datiPaziente}
                        datiMedico={this.state.datiMedico}
                        datiCompletiECorretti={this.state.datiCompletiECorretti}
                        showSpinner={this.showLoadingSpinner}
                        infoLaboratorio={this.state.infoLaboratorio}
                        segnalazione={
                            this.state.segnalazione
                                ? this.state.segnalazione
                                : ""
                        }
                        segnalazioneCopia={
                            this.state.segnalazioneCopia
                                ? this.state.segnalazioneCopia
                                : ""
                        }
                        updateWizardState={this.updateState}
                    />
                );
                return this.setState({ step: step });
            case states.ESITO:
                step = (
                    <Esito
                        navLabel={this.navLabel}
                        datiPaziente={this.state.datiPaziente}
                        datiMedico={this.state.datiMedico}
                        datiCompletiECorretti={this.state.datiCompletiECorretti}
                        showSpinner={this.showLoadingSpinner}
                        segnalazione={
                            this.state.segnalazione
                                ? this.state.segnalazione
                                : ""
                        }
                        segnalazioneCopia={
                            this.state.segnalazioneCopia
                                ? this.state.segnalazioneCopia
                                : ""
                        }
                        updateWizardState={this.updateState}
                        listaSezioni={this.state.listaSezioni}
                        infoMalattia={
                            this.props.location.state &&
                            this.props.location.state.infoMalattia
                                ? this.props.location.state.infoMalattia
                                : this.state.infoMalattia
                                ? this.state.infoMalattia
                                : ""
                        }
                        malattiePremal = {OggettiUtili.malattiePremalCodici}
                    />
                );
                return this.setState({ step: step });
            case states.DATI_SPECIFICI:
                step = (
                    <DatiSpecifici
                        navLabel={this.navLabel}
                        listaSezioni={
                            this.state.listaSezioni
                                ? this.state.listaSezioni
                                : []
                        }
                        datiPaziente={this.state.datiPaziente}
                        datiMedico={this.state.datiMedico}
                        datiCompletiECorretti={this.state.datiCompletiECorretti}
                        showSpinner={this.showLoadingSpinner}
                        segnalazione={
                            this.state.segnalazione
                                ? this.state.segnalazione
                                : ""
                        }
                        segnalazioneCopia={
                            this.state.segnalazioneCopia
                                ? this.state.segnalazioneCopia
                                : ""
                        }
                        updateWizardState={this.updateState}
                        infoMalattia={
                            this.props.location.state &&
                            this.props.location.state.infoMalattia
                                ? this.props.location.state.infoMalattia
                                : this.state.infoMalattia
                                ? this.state.infoMalattia
                                : ""
                        }
                        malattiePremal = {OggettiUtili.malattiePremalCodici}
                    />
                );
                return this.setState({ step: step });
            case states.SCHEDA_SPECIALE:
                step = (
                    <SchedaSpeciale
                        navLabel={this.navLabel}
                        datiPaziente={this.state.datiPaziente}
                        datiMedico={this.state.datiMedico}
                        datiCompletiECorretti={this.state.datiCompletiECorretti}
                        malattia={
                            this.props.location.malattia
                                ? this.props.location.malattia
                                : this.state.segnalazione.malattia
                        }
                        showSpinner={this.showLoadingSpinner}
                        segnalazione={
                            this.state.segnalazione
                                ? this.state.segnalazione
                                : ""
                        }
                        segnalazioneCopia={
                            this.state.segnalazioneCopia
                                ? this.state.segnalazioneCopia
                                : ""
                        }
                        infoMalattia={
                            this.props.location.state &&
                            this.props.location.state.infoMalattia
                                ? this.props.location.state.infoMalattia
                                : this.state.infoMalattia
                                ? this.state.infoMalattia
                                : ""
                        }
                        updateWizardState={this.updateState}
                    />
                );
                return this.setState({ step: step });
            case states.SCHEDA_SPECIALE_ESITO_TBC:
                step = (
                    <SchedaSpecialeTrattamentoTbc
                        navLabel={this.navLabel}
                        datiPaziente={this.state.datiPaziente}
                        datiMedico={this.state.datiMedico}
                        datiCompletiECorretti={this.state.datiCompletiECorretti}
                        showSpinner={this.showLoadingSpinner}
                        segnalazione={
                            this.state.segnalazione
                                ? this.state.segnalazione
                                : ""
                        }
                        segnalazioneCopia={
                            this.state.segnalazioneCopia
                                ? this.state.segnalazioneCopia
                                : ""
                        }
                        infoMalattia={
                            this.props.location.state.infoMalattia
                                ? this.props.location.state.infoMalattia
                                : this.state.infoMalattia
                                ? this.state.infoMalattia
                                : ""
                        }
                        updateWizardState={this.updateState}
                    />
                );
                return this.setState({ step: step });
            default:
                step = (
                    <DatiSegnalazioneAnagrafici
                        showSpinner={this.showLoadingSpinner}
                        datiCompletiECorretti={this.state.datiCompletiECorretti}
                        segnalazione={
                            this.state.segnalazione
                                ? this.state.segnalazione
                                : ""
                        }
                        segnalazioneCopia={
                            this.state.segnalazioneCopia
                                ? this.state.segnalazioneCopia
                                : ""
                        }
                        datiMedico={this.state.datiMedico}
                    />
                );
                return this.setState({ step: step });
        }
    }

    mostraTabellaSegnalazioni() {
        if (this.state.mostraTabellaSegnalazioni === false) {
            this.sendRequest();
        } else if (this.state.mostraTabellaSegnalazioni === true) {
            this.setState({ mostraTabellaSegnalazioni: false });
        }
    }

    buildAltreSegnalazioniRequest() {
        //MOCKUP - ulss dell'utente loggato
        let params = {
            ulss: SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp.descrizione
                || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp_HIV.descrizione
                ? SessioneUtente.getInstance().ulss : null,
            malattia: SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp.descrizione
                || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp_HIV.descrizione
                ? this.state.segnalazione.malattia : null,
            idSegnalazione: Utils.getIdSegnalazioneUlss(this.state.segnalazione.ulssSegnalazione, this.state.segnalazione.idSegnalazione),
        };

        if (this.state.datiPaziente.codiceFiscale && this.state.datiPaziente.codiceFiscale !== "") {
            params["codiceFiscale"] = this.state.datiPaziente.codiceFiscale.toUpperCase();
        }
        else if (this.state.datiPaziente.stp && this.state.datiPaziente.stp !== "") {
            params["stp"] = this.state.datiPaziente.stp.toUpperCase();
        } else {
            params = {};
        }

        return Utils.removeEmptyValueFromObject(params);
    }

    changePageTable(sort, direction, page, size) {
        let segnalazioniRequestParam = this.buildAltreSegnalazioniRequest();

        if (page) {
            segnalazioniRequestParam["page"] = page;
        }
        if (size) {
            if (size !== this.state.sizeTabSegnalazioni) {
                segnalazioniRequestParam["size"] =
                    this.state.sizeTabSegnalazioni;
            } else {
                segnalazioniRequestParam["size"] = size;
            }
        }
        if (direction) {
            segnalazioniRequestParam["order"] = direction;
        }
        if (sort) segnalazioniRequestParam["sort"] = sort;

        this.showLoadingSpinner(true);
        SegnalazioniService.getAltreSegnalazioni(segnalazioniRequestParam)
            .then((data) => {
                let res = SegnalazioniService.mapGetSegnalazioni(data)
                this.showLoadingSpinner(false);
                this.setState({
                    mostraTabellaSegnalazioni: true,
                    rowsTabSegnalazioni: res,
                    totalElementsTabSegnalazioni: data.data.totalElements,
                    totalPagesTabSegnalazioni: data.data.totalPages,
                    pageTabSegnalazioni: page,
                });
            })
            .catch(() => {
                console.log("[Error] GetAltreSegnalazioni in errore ");
                this.setState({
                    rowsTabSegnalazioni: [],
                    totalElementsTabSegnalazioni: 0,
                    loading: false,
                });
            });
    }

    changePaginationTable(sort, direction, page, size) {
        let segnalazioniRequestParam = this.buildAltreSegnalazioniRequest();
        segnalazioniRequestParam["page"] = page;
        segnalazioniRequestParam["size"] = size;

        if (sort) {
            segnalazioniRequestParam["sort"] = sort;
        }

        if (direction) {
            segnalazioniRequestParam["order"] = direction;
        }

        this.setState({ sizeTabSegnalazioni: size, loading: true });
        SegnalazioniService.getAltreSegnalazioni(segnalazioniRequestParam)
            .then((data) => {
                let res = SegnalazioniService.mapGetSegnalazioni(data)

                this.setState({
                    loading: false,
                    mostraTabellaSegnalazioni: true,
                    rowsTabSegnalazioni: res,
                    totalElementsTabSegnalazioni: data.data.totalElements,
                    totalPagesTabSegnalazioni: data.data.totalPages,
                    pageTabSegnalazioni: page,
                });
            }).catch(() => {
                console.log("[Error] GetAltreSegnalazioni in errore ");
                this.setState({
                    rowsTabSegnalazioni: [],
                    totalElementsTabSegnalazioni: 0,
                    loading: false,
                });
            });
    }

    sendRequest() {
        let params = this.buildAltreSegnalazioniRequest();
        if (Utils.isEmpty(params)) {
            this.aggiungiToaster([
                "Messages.ERR_MISS_ANAGRAFICA",
            ]);
        } else {
            this.showLoadingSpinner(true);
            SegnalazioniService.getAltreSegnalazioni(params).then((data) => {
                let res = SegnalazioniService.mapGetSegnalazioni(data)

                this.setState({
                    loading: false,
                    mostraTabellaSegnalazioni: true,
                    rowsTabSegnalazioni: res,
                    totalPagesTabSegnalazioni: data.data.totalPages,
                    totalElementsTabSegnalazioni: data.data.totalElements,
                });
            }).catch(() => {
                console.log("[Error] GetAltreSegnalazioni in errore ");
                this.setState({
                    loading: false,
                    mostraTabellaSegnalazioni: true,
                    rowsTabSegnalazioni: [],
                    totalPagesTabSegnalazioni: 0,
                    totalElementsTabSegnalazioni: 0,
                });
            });
        }
    }

    onClickTornaAllaRicerca() {
        let path = sessionStorage.getItem("pathProvenienza")? sessionStorage.getItem("pathProvenienza") : "/ricercaSegnalazioni"
        sessionStorage.removeItem("pathProvenienza")
        history.push({ pathname: path });
    }

    render() {
        const { t } = this.props;
        const tableUtente = (
            <div className={"col-xl-9"}>
                <TableDatiUtente
                    idSegnalazione={Utils.getIdSegnalazioneUlss(
                        this.state.segnalazioneCopia.ulssSegnalazione,
                        this.state.segnalazioneCopia.idSegnalazione
                    )}
                    datiUtente={this.state.datiPaziente}
                    idoneitaPremal={this.state.segnalazione.idoneitaPremal}
                    statoSegnalazione={
                        this.state.segnalazione &&
                        this.state.segnalazione.statoSegnalazione
                            ? this.state.segnalazione.statoSegnalazione
                            : ""
                    }
                />
            </div>
        );

        const infoDataMigrazione = (
            <div>
                <h6 className={styleWizardPanel.marginText}>
                    La segnalazione in esame è stata importata dal vecchio
                    sistema di segnalazione (SimiWeb) in data{" "}
                    {Utils.transformDateForFrontend(
                        this.state.segnalazione.dataMigrazione
                    )}
                    .
                </h6>
            </div>
        );

        const tableSegnalazioniUtente = (
            <div className="container mt-3">
                <div
                    className={styles.contenitoreTabella}
                    style={{ marginTop: "2px"}}
                >
                    <Table
                        id={"tabSegnalazioniPrecedenti"}
                        cols={this.colsTabSegnalaioni}
                        rows={this.state.rowsTabSegnalazioni}
                        title={t(
                            "GestioneSegnalazioni.info_segnalazione.titolo_tabella_segnalazioni"
                        )}
                        empty={
                            this.state.rowsTabSegnalazioni &&
                            this.state.rowsTabSegnalazioni.length === 0
                        }
                        emptyMsg={t(
                            "GestioneSegnalazioni.info_segnalazione.no_segnalazioni"
                        )}
                        bigTable={true}
                        lengthEditable={true}
                        totalPages={this.state.totalPagesTabSegnalazioni}
                        page={this.state.pageTabSegnalazioni}
                        changePage={this.changePageTable}
                        totalElements={this.state.totalElementsTabSegnalazioni}
                        changePagination={this.changePaginationTable}
                    />
                </div>
            </div>
        );

        const formTableSegnalazioniEdatiUtente = (
            <div className={"container"}>
                <div
                    className={
                        this.state.segnalazione?.idoneitaPremal?.idoneita ===
                        false
                            ? "row justify-content-xl-end"
                            : "row"
                    }
                >
                    {tableUtente}
                    <div
                        className={"col-xl-3"}
                        style={{ display: (this.state.datiPaziente.cognomePaziente === "ANONIMO" && this.state.datiPaziente.nomePaziente === "ANONIMO") ||
                                (this.state.datiPaziente.codiceFiscale === "" && this.state.datiPaziente.stp === "") ? "none" : ""}}>
                        <Button
                            id={"buttonAltreSegnalazioni"}
                            onClick={() => {
                                this.mostraTabellaSegnalazioni();
                            }}
                            className={
                                stylesInfoCliniche.testo +
                                " " +
                                stylesInfoCliniche.btnBluOutline
                            }
                            classes="btn mt-2 btnBluOutline mb-1 "
                            style={{
                                padding: "5px",
                                outline: "none",
                                border: "none",
                                background: "none",
                                float: "right",
                                fontSize: "14px",
                            }}
                            text={t(
                                "GestioneSegnalazioni.info_segnalazione.segnalazioni_precedenti"
                            )}
                            icon={
                                <Icon
                                    style={{
                                        fill: "#0073e6",
                                        width: "32px",
                                        height: "32px",
                                        paddingBottom: "10px",
                                    }}
                                    id={
                                        this.state.mostraTabellaSegnalazioni
                                            ? "it-minus-circle"
                                            : "it-plus-circle"
                                    }
                                />
                            }
                        />
                    </div>
                    {this.state.segnalazione?.idoneitaPremal?.idoneita ===
                    false ? (
                        <div className={"col-xl-3"}>
                            <h6 className={styles.msgIdoneitaPremal}>
                                La segnalazione non è idonea per l'invio a
                                Premal
                            </h6>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
                {this.state.mostraTabellaSegnalazioni ? (
                    <div>{tableSegnalazioniUtente}</div>
                ) : (
                    <div />
                )}
            </div>
        );

        const spinnerDiv = (
            <div>
                <Spinner />
            </div>
        );

        return (
            <div>
                {this.state.loading ? <div>{spinnerDiv}</div> : <div />}
                {ToasterSingleton.instance().renderToaster()}
                {this.state.segnalazione &&
                this.state.segnalazione.idSegnalazione ? (
                    <div>
                        <div>
                            <Button
                                id={"tornaAllaRicerca"}
                                text={t("Buttons.torna_alla_ricerca")}
                                className={["btnWhite", "col-lg-12"].join(" ")}
                                style={{
                                    height: "2rem",
                                    fontSize: "15px",
                                    float: "right",
                                    width: "15vw",
                                }}
                                onClick={() => {
                                    this.onClickTornaAllaRicerca();
                                }}
                            />
                        </div>
                        <br />
                    </div>
                ) : (
                    <></>
                )}

                <StepProgressBar
                    listaSezioni={this.state.listaSezioni}
                    infoSchedaSpeciale={this.state.infoMalattia.schedaSpeciale}
                    codiceMalattia={
                        this.props.location.malattia
                            ? this.props.location.malattia
                            : this.state.segnalazione.malattia
                    }
                    isArchiviato={
                        (this.state.segnalazione &&
                            this.state.segnalazione.migrazione) ||
                        (this.state.segnalazioneCopia &&
                            (this.state.segnalazioneCopia.statoSegnalazione ===
                                OggettiUtili.statoSegnalazioneByLabel.Archiviato
                                    .codice ||
                                this.state.segnalazioneCopia
                                    .statoValidazione ===
                                    OggettiUtili.statoValidazioneByLabel
                                        .Validata.codice))
                    }
                    pagina={this.state.currentState}
                    datiCompletiECorretti={this.state.datiCompletiECorretti}
                    esitoTbc={
                        this.state.segnalazione.schedaSpeciale &&
                        this.state.segnalazione.schedaSpeciale
                            .caratteristicheDellaMalattia &&
                        this.state.segnalazione.schedaSpeciale
                            .caratteristicheDellaMalattia.polTrachBron ===
                            "true"
                    }
                />

                {this.state.segnalazione.migrazione ? (
                    <div>{infoDataMigrazione}</div>
                ) : null}
                {this.state.currentState ===
                states.DATI_SEGNALAZIONE_E_ANAGRAFICI ? (
                    <div />
                ) : (
                    <div style={{ marginTop: "1rem" }}>
                        {formTableSegnalazioniEdatiUtente}
                    </div>
                )}
                <div
                    style={{
                        marginTop: this.state.mostraTabellaSegnalazioni
                            ? "5rem"
                            : "",
                    }}
                >
                    <div>{this.state.step ? this.state.step : ""}</div>
                </div>
            </div>
        );
    }
}

export default withTranslation("common")(WizardPanel);
